import React from "react";
export function headline(data) {
  var params = new URLSearchParams(window.location.search);
  var hc = params.get("hc");
  var kw = params.get("kw");
  var bn = params.get("bn");
  var qsData = {};
  if (hc) {
    qsData.headline = hc;
  }
  if (kw) {
    qsData.subhead = kw;
  }
  if (bn) {
    qsData.mainCTA = bn;
  }
  if (qsData) {
    return Object.assign(data, qsData);
  }
}